import axiosInstance from "./axiosInstance";
import {Organization, Role, Team, User} from "../types/users";

export async function login(email: string, password: string) {
    const response = await axiosInstance.post( '/auth/login', {email, password});
    return response.data;
}

export async function logout() {
    const response = await axiosInstance.post('/auth/logout')
    return response.data;
}

export async function verifyToken() {
    const response = await axiosInstance.get(process.env.REACT_APP_BASE_URL + '/auth/verifyToken')
    return response.data
}

export async function updateUser (user: User, idUser: string) {
    const response = await axiosInstance.put(`/user/${idUser}`, user);
    return response.data;
}

export async function changePassword(idUser: string) {
    const response = await axiosInstance.post(`/user/${idUser}/password`, {password: idUser});
    return response.data;
}

export async function getUsers(): Promise<User[]> {
    const response = await axiosInstance.get(`/user/users`);
    return response.data;
}

export async function createUser(user: User){
    const response = await axiosInstance.post(`/user`, user);
    return response.data;
}

export async function deleteUser(userId: string) {
    const response = await axiosInstance.delete(`/user/${userId}`);
    return response.data;
}

export async function getRoles(): Promise<Role[]> {
    const response = await axiosInstance.get(`/user/roles`);
    return response.data;
}

export async function getOrganizations(): Promise<Organization[]> {
    const response = await axiosInstance.get(`/user/organizations`);
    return response.data;
}

export async function createOrganization(organization: Organization): Promise<{id: string}> {
    const response = await axiosInstance.post(`/user/organization`, organization);
    return response.data;
}

export async function updateOrganization(organization: Organization): Promise<void> {
    const response = await axiosInstance.put(`/user/organization/${organization.id}`, organization);
    return response.data;
}

export async function deleteOrganization(organizationId: string): Promise<void> {
    const response = await axiosInstance.delete(`/user/organization/${organizationId}`);
    return response.data;
}

export async function getUser(userId: string): Promise<Role[]> {
    const response = await axiosInstance.get(`/user/${userId}`);
    return response.data;
}

export async function passwordChange(userId: string, password: string) {
    const response = await axiosInstance.post(`/user/${userId}/change_password`, {password: password});
    return response.data;
}

export async function getTeams(id_competitions: string[]): Promise<any> {
    const params = {id_competitions}
    const response = await axiosInstance.get(`/user/teams`, {params});
    return response.data;
}


